import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ComGoalEmployeeJobModel } from 'src/app/model/com-goal-employee-job.model';

@Injectable({
  providedIn: 'root'
})
export class ComGoalEmployeeJobService {
  private url:string;

  ////////////////
  constructor(
    private http:HttpClient
  ) {
    this.url=environment.services_url;
  }

  //
  getAll=()=> {
    return this.http.get(`${this.url}/CommissionGoalEmployeeJob/List`)
      .pipe(
        map((resp:any)=> resp)
      );
  }


  save=(commission:ComGoalEmployeeJobModel)=> {
    return this.http.post(`${this.url}/CommissionGoalEmployeeJob/SaveUpdate`, commission)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  saveAll=(commissions:ComGoalEmployeeJobModel[])=> {
    return this.http.post(`${this.url}/CommissionGoalEmployeeJob/saveAll`, commissions)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  update=(commission:ComGoalEmployeeJobModel)=> {
    return this.http.post(`${this.url}/CommissionGoalEmployeeJob/SaveUpdate/${commission.goalEmployeeJobId}`, commission)
      .pipe(
        map((resp:any)=> resp)
      );
  }
}
